exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fn9v{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "fn9v",
	"root": "fn9v"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./containers/strategieWeb/strategieWeb.css
// module id = 239
// module chunks = 0